import SelfAssessmentBase from 'es6/controllers/apps/quizzes/self-assessment-base';

export class ReverseSelfAssessment extends SelfAssessmentBase {
  constructor(...args) {
    super(...args);
    this._setQuizType('ReverseSelfAssessment');
    this._recallResponse = this.itemPackage.getTranslation();
    this.followUpQuiz = ReverseSelfAssessmentBinary;
  }
}

export class ReverseSelfAssessmentBinary extends ReverseSelfAssessment {
  constructor(...args) {
    super(...args);
    this._setQuizType('ReverseSelfAssessmentBinary');
    this._isRepeat = true;
  }
}

export default ReverseSelfAssessment;
